import React, { useState } from "react";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import { Button, Col, Form, Input, InputNumber, Row, Spin } from "antd";
import Style from "./AddFactorContainer.module.css";
import { Search as SearchIcon } from "react-bootstrap-icons";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import { createFActorApi, searchUserByPhoneAPI } from "../../../Api/PanelAdminServices";
const AddFactorContainer = () => {
  const [phonenumber, setPhoneNumber] = useState();
  const [disableForm, setDisable] = useState(true);
  const [loadingState, setLoadingState] = useState(false);
  const [userInfoState, setUserInfoState] = useState();
  const { Search, TextArea } = Input;
  const [form] = Form.useForm();
  const findUserHandler = () => {
    const phoneRegex = /^09\d{9}$/;
    if (!phoneRegex.test(phonenumber)) {
      errorToast("شماره وارد شده معتبر نیست.");
      return;
    }
    setLoadingState(true);
    let info = {
      phone: phonenumber,
      user_type: "user",
      user_id: "",
    };

    searchUserByPhoneAPI(info, (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          setUserInfoState(res.users[0]);
          setLoadingState(false);
          setDisable(false);
        } else {
          errorToast(res.message);
          setLoadingState(false);
        }
      } else {
        console.error(res);
        setLoadingState(false);
      }
    });
  };
  const submitFactorHandler=(value)=>{
    const info={
      amount:value.payment,
      description:value?.description,
      assigned_user_id:userInfoState.id,
      assigned_user_type:"user",
      cause:1
    }
    setLoadingState(true);
    createFActorApi(info, (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          succToast("فاکتور با موفقیت ایجاد شد!")
          setLoadingState(false);
        } else {
          errorToast(res.message);
          setLoadingState(false);
        }
      } else {
        console.error(res);
        setLoadingState(false);
      }
    });
  }
  return (
    <div className="factor__addFactor">
      <TableFixedPage title={"افزودن فاکتور"} />
      <Form
        form={form}
        className={Style.FormHolder}
        dir="rtl"
        layout="vertical"
        labelAlign="right"
        colon={false}
        onFinish={submitFactorHandler}
      >
        <Row gutter={16}>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              labelAlign="right"
              label="شماره تلفن کاربر"
              name="phone"
            >
              <div className={Style.SearchNumberHolder}>
                <Input
                  value={phonenumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  name="phone"
                  type="tel"
                  style={{ width: "100%", textAlign: "center" }}
                />
                <button type="button" onClick={findUserHandler}>
                  <SearchIcon />
                </button>
              </div>
              <p>
                {loadingState ? (
                  <>
                    <Spin />
                    لطفا صبرکنید...
                  </>
                ) : null}
              </p>
              {userInfoState && (
                <p>{`${userInfoState.first_name} ${userInfoState.last_name}`}</p>
              )}
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="مبلغ"
              name="payment"
              rules={[{ required: true, message: "لطفا مبلغ را وارد کنید!" }]}
            >
              <InputNumber
                formatter={(value) =>
                  `تومان ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                controls={false}
                disabled={disableForm}
                style={{ width: "100%", textAlign: "center" }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="توضیحات" name="description">
          <TextArea
            disabled={disableForm}
            style={{ resize: "none", width: "100%", textAlign: "right",height:"10rem" }}
          />
        </Form.Item>

        <Form.Item>
          <Button
            style={{
              background: "#bb006d",
              color: "#fff",
              width: "100%",
              height: "2rem",
              border:"none"
            }}
            type="primary"
            htmlType="submit"
            disabled={loadingState}
          >
            ثبت
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddFactorContainer;
